export const AUTH='AUTH';
export const DELETE_ACCOUNT='DELETE_ACCOUNT';
export const AUTH_DATA='AUTH_DATA';
export const START_LOADING_AUTH='START_LOADING_AUTH';
export const END_LOADING_AUTH='END_LOADING_AUTH';
export const LOGOUT = 'LOGOUT'